import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Pagination = ({ totalPages, currentPage, onPageChange }) => {
  return (
    <>
      {/* Styles inside React component */}
      <style>{`
        .pagination-container {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;
        }

        .pagination-btn {
          border: none;
          color: #34495e;
          font-size: 14px;
          font-weight: 500;
          padding: 6px 10px;
          border-radius: 50%;
          width: 36px;
          height: 36px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all 0.2s ease-in-out;
        }

        .pagination-btn:hover {
          background: rgba(25, 118, 210, 0.08);
        }

        .pagination-btn:disabled {
          color: #bdbdbd;
          cursor: not-allowed;
        }

        .pagination-btn.active {
          background: #34495e;
          color: white;
        }

        .pagination-dots {
          padding: 6px 10px;
          font-size: 14px;
          color: #757575;
        }
      `}</style>

      <div className="pagination-container">
        {/* Previous Button */}
        <button
          className="pagination-btn"
          disabled={currentPage === 0}
          onClick={() => onPageChange(currentPage - 1)}
        >
          <FaArrowLeft />
        </button>

        {totalPages <= 7 ? (
          [...Array(totalPages).keys()].map((pageNumber) => (
            <button
              key={pageNumber}
              className={`pagination-btn ${
                pageNumber === currentPage ? "active" : ""
              }`}
              onClick={() => onPageChange(pageNumber)}
            >
              {pageNumber + 1}
            </button>
          ))
        ) : (
          <>
            {currentPage > 1 && (
              <>
                <button
                  className="pagination-btn"
                  onClick={() => onPageChange(0)}
                >
                  1
                </button>
                {currentPage > 2 && (
                  <span className="pagination-dots">...</span>
                )}
              </>
            )}

            {[...Array(totalPages).keys()]
              .filter(
                (pageNumber) =>
                  pageNumber >= currentPage - 1 &&
                  pageNumber <= currentPage + 1
              )
              .map((pageNumber) => (
                <button
                  key={pageNumber}
                  className={`pagination-btn ${
                    pageNumber === currentPage ? "active" : ""
                  }`}
                  onClick={() => onPageChange(pageNumber)}
                >
                  {pageNumber + 1}
                </button>
              ))}

            {currentPage < totalPages - 2 && (
              <>
                {currentPage < totalPages - 3 && (
                  <span className="pagination-dots">...</span>
                )}
                <button
                  className="pagination-btn"
                  onClick={() => onPageChange(totalPages - 1)}
                >
                  {totalPages}
                </button>
              </>
            )}
          </>
        )}

        {/* Next Button */}
        <button
          className="pagination-btn"
          disabled={currentPage + 1 === totalPages}
          onClick={() => onPageChange(currentPage + 1)}
        >
          <FaArrowRight />
        </button>
      </div>
    </>
  );
};

export default Pagination;